import React from "react";

import Tabs from "components/Tabs/index";
import SettingIcons from "../../../constants/Homepage/setting/index";
import "./settings.scss";

function Settings({ activeTab, setActiveTab, NoBilling, isAdmin }) {
  const userType = sessionStorage.getItem("usertype");
  const tabsTitles =
    userType === "SuperAdmin"
      ? ["General", "Security", "Admin"]
      : userType === "Employee"
        ? (isAdmin ? ["General", "Security", "Admin"] : ["General", "Security"])
        : ["General", "Security"];

  const tabIconKeys = userType === "SuperAdmin"
    ? ["general", "security", "admin"]
    : userType === "Employee"
      ? (isAdmin ? ["general", "security", "admin"] : ["general", "security"])
      : NoBilling
        ? ["general", "security"]
        : ["general", "security", "billing"];

  return (
    <>
      <div className="Setting">
        {window.innerWidth <= 992 && (
          <div className="SettingTitle">
            <p>Settings</p>
            <div
              className="SettingClose"
              onClick={() => {
                if (window.innerWidth <= 992) {
                  document.dispatchEvent(new CustomEvent("closeSettingsToProfile"));
                } else {
                  window.history.back();
                }
              }}
            >
              <span>✕</span>
            </div>
          </div>
        )}
        <div className="SettingTabs">
          <Tabs
            tabsTitles={tabsTitles}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabIconKeys={tabIconKeys}
            TabIcons={SettingIcons}
            marginBottom="0"
          />
        </div>
      </div>
    </>
  );
}

export default Settings;
